<template>
    <section class="search-no-results">
        <div class="container">
            <div class="search-no-results__info">
                <h3 class="search-no-results__info-text">Brak wyników dla podanej frazy</h3>
            </div>
            <div class="search-no-results__desc column is-12-tablet is-10-desktop is-offset-1-desktop">
                <p class="search-no-results__desc-text">Propozycje:</p>
                <ul>
                    <li class="search-no-results__desc-text">Upewnij się, że wszystkie słowa są poprawnie napisane.</li>
                    <li class="search-no-results__desc-text">Wypróbuj inne słowa kluczowe.</li>
                    <li class="search-no-results__desc-text">Spróbuj bardziej ogólnych słów kluczowych.</li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "SearchNoResults"
};
</script>
